export default __webpack_public_path__ + "assets/images/aistudio/empty_state/283b42f4c18d65b8291c0efe1a426566.png";